import type {
  SystemStyleInterpolation,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { Input } from "./input"
import { sizesOptions } from "../common/sizeOptions"

const baseStyle: SystemStyleObject = {
  ...Input.baseStyle.field,
  paddingY: "8px",
  lineHeight: "short",
  verticalAlign: "top",
  minH: 'auto',
}

const variants: Record<string, SystemStyleInterpolation> = {
  outline: (props) => Input.variants.outline(props).field ?? {},
  flushed: (props) => Input.variants.flushed(props).field ?? {},
  filled: (props) => Input.variants.filled(props).field ?? {},
  unstyled: Input.variants.unstyled.field ?? {},
}

const sizes: Record<string, SystemStyleObject> = {
  xs: {
    ...sizesOptions.xs,
    py: sizesOptions.xs.px,
    h: '6xl',
  },
  sm: {
    ...sizesOptions.sm,
    py: sizesOptions.sm.px,
    h: '8xl',
  },
  md: {
    ...sizesOptions.md,
    py: sizesOptions.md.px,
    h: '11xl',
  },
  lg: {
    ...sizesOptions.lg,
    py: sizesOptions.lg.px,
    h: '16xl',
  },
}

const defaultProps = {
  size: "md",
  variant: "outline",
}

export const Textarea = {
  baseStyle,
  sizes,
  variants,
  defaultProps,
}